module.exports = __webpack_public_path__ + "img/2.7bd99f67.png";